import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { Box, ListRow, renderListRows } from '@tq/ui-components';

import { useIsMobile } from '@tq/ui-components/dist/hooks';
import { AddressResponse } from 'types';

export type AddressDetailProps = {
  relatedAddress: AddressResponse;
};

export const AddressDetail: React.FC<AddressDetailProps> = ({ relatedAddress }) => {
  const { t } = useTranslation('case_details_related');
  const isMobile = useIsMobile();
  const columnLayout = isMobile ? '35% 65%' : '30% 70%';
  const bodyRows = [
    {
      label: t('address_title', 'Address'),
      value: relatedAddress.address,
    },
    {
      label: t('postcode_title', 'Postcode'),
      value: relatedAddress.postcode,
    },
    {
      label: t('authority_title', 'Authority'),
      value: relatedAddress.authority,
    },
  ];
  return (
    <Box py={0} px={4} pb={2} borderBottom={`1px solid ${COLOURS.gray[400]}`}>
      <ListRow listItemColumns={columnLayout}>
        {renderListRows(bodyRows, { fontSize: 'sm' })}
      </ListRow>
    </Box>
  );
};
